import React from "react";
import { getUser } from "../../utils/Storage";
import MyAttendanceCalendar from "./MyAttendanceCalendar";
import PageShell from "../../v2/components/shared/page-shell/page-shell.tsx";
import clsx from "clsx";
import styles from "./my-attendance.module.css";

const MyAttendance = ({ title, description }) => {
  const userData = JSON.parse(getUser("userData"));

  return (
    <PageShell className={styles.pageShell}>
     

      {Object.keys(userData).length > 0 && (
        <MyAttendanceCalendar selectedEmployee={userData} />
      )}
    </PageShell>
  );
};

export default MyAttendance;
